'use client';
import { Grid, SxProps, Theme } from '@mui/material';
import { CommonCollectionTypeAttributes, EntityCollection } from '@peerless/data-access/strapi';
import { PreviewCard } from './PreviewCard';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface Props {
  previews: EntityCollection<CommonCollectionTypeAttributes>;
  urlLabel: string;
  icon: IconProp;
  urlPath: string;
  sx?: SxProps<Theme>;
  hideDate?: boolean;
}

export function PreviewCardGrid({ previews, urlLabel, icon, urlPath, sx, hideDate }: Props) {
  return (
    <Grid container spacing={4}>
      {previews.data.map(data => {
        const preview = data?.attributes?.preview;
        if (!preview) return null;
        return (
          <Grid item xs={12} md={6} lg={4} key={data.id}>
            <PreviewCard
              title={data.attributes.title}
              description={preview.description}
              externalUrlLink={preview.externalUrlLink}
              pageUrlLink={`${urlPath}/${data.attributes.slug}`}
              internalDocumentLink={preview.internalDocumentLink}
              image={preview.image}
              urlLabel={urlLabel}
              icon={icon}
              date={preview.date}
              sx={sx}
              hideDate={hideDate}
              subHeader={preview.subHeader}
            />
          </Grid>
        );
      })}
    </Grid>
  );
}
